import React from 'react'
import ChangeParentPasswordForm from '../Forms/ChangeParentPasswordForm';

const ModalChangeParentPassword = () => {
    return (
        <div className="modal-content">
            <h1 className="h-text-center">Změna rodičovského hesla</h1>
            <ChangeParentPasswordForm />
        </div>
    );
}

export default ModalChangeParentPassword
